<template>
    <section class="interview-title pink">
        <div class="css-grid">
            <div class="bg" style="background-image: url(/static/img/pages/interview-kirsten.jpg)"></div>

            <div class="content-wrapper">
                <div class="content pink">
                    <h3>Interview Kirsten&nbsp;Cuppen</h3>
                    <h2>Focus op sociale ontwikkeling</h2>
                    <button class="white" @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped></style>

<script>
    import InterviewKirsten from '@/app/pages/sub/InterviewKirsten';

    export default {
        name: 'OnderwijskwaliteitInterview',
        meta: {
            title: 'OnderwijskwaliteitInterview',
            color: '#fe1362'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewKirsten );
            }
        }
    };
</script>
